export const xAxisTitle = {
  id: 'xAxisTitle',
  afterDraw: (chart, args, options) => {
    const {
      ctx,
      chartArea: { bottom, right }
    } = chart;
    ctx.save();
    ctx.font = `${options.fontSize}} Roboto`;
    ctx.fillStyle = options.fontColor;
    ctx.textAlign = 'left';   // align text to the left
    ctx.textBaseline = 'bottom'; // align text to the bottom
    ctx.fillText(options.text, right + 12, bottom + 3);
    ctx.restore();
  }
};